import React, { useEffect, useState, useMemo } from "react";
import styled from "styled-components";
import useZibi from "../../zibi/UseZibi";
import { api } from "../../maps/data";
import Icn from "../../components/Icn";
import Tx from "../../components/Tx";
import PageTitle from "../../components/PageTitle";
import CategoriesShow from "../../components/inventoryManagement/CategoriesShow";
import {
  addOrDeleteQueryParams,
  getQueryValue,
} from "../../domain/queryHandler";
import { useNavigate, useLocation } from "react-router-dom";
import ProductsShow from "../../components/inventoryManagement/ProductsShow";
import { Drawer } from "@mui/material";
import ProductInventoryEdit from "../../components/inventoryManagement/ProductInventoryEdit";

const WrapperStyled = styled.div``;

const InventoryManagementPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [currentSite, set_currentSite] = useZibi("currentSite");
  const [categories, set_categories] = useZibi("categories");
  const [products, setProducts] = useState([]);
  const [selectProductIndex, setSelectProductIndex] = useState(null);

  const selectedCategoryId = useMemo(
    () => getQueryValue(location, "category"),
    [location]
  );

  useEffect(() => {
    getSite();
    getCategoriesData();
  }, []);

  useEffect(() => {
    if (selectedCategoryId) {
      getProducts(selectedCategoryId);
    }
  }, [selectedCategoryId]);

  const getProducts = async (categoryId, searchQuery) => {
    try {
      const fetchedProducts = await api({
        type: "getInventoryProducts",
        data: { categoryId, search: searchQuery },
        // disableBI: true,
        disableEH: true,
      });
      setProducts((prevProducts) =>
        JSON.stringify(prevProducts) !== JSON.stringify(fetchedProducts)
          ? fetchedProducts
          : prevProducts
      );
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const getCategoriesData = async () => {
    if (!categories || categories.length === 0) {
      try {
        const fetchedCategories = await api({
          type: "getCategoriesWithProductCount",
        });
        set_categories(fetchedCategories.sort((a, b) => a.order - b.order));
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    }
  };

  const getSite = async () => {
    if (!currentSite) {
      try {
        const res = await api({ type: "getSites", data: {} });
        set_currentSite(res?.[0] || null);
      } catch (error) {
        console.error("Error fetching site:", error);
      }
    }
  };

  const changeUrl = (query) => {
    if (location.search !== query) {
      navigate({ search: query });
    }
  };

  return (
    <div style={{ height: "100%", padding: 20, overflow: "auto" }}>
      <PageTitle>
        <div style={{ position: "relative" }}>
          <Icn>inventoryIcon</Icn> <Tx>menu.inventory</Tx>
        </div>
      </PageTitle>
      <WrapperStyled>
        {/* <CategoriesShow
          items={categories}
          m={selectedCategoryId}
          selectItemHandle={(cateId) => {
            const urlToPush = addOrDeleteQueryParams(location, [
              { category: cateId === selectedCategoryId ? null : cateId },
            ]);
            changeUrl(urlToPush);
          }}
        /> */}

        <CategoriesShow
          items={categories}
          selectedItemId={selectedCategoryId} // Make sure the correct `selectedCategoryId` is passed here
          selectItemHandle={(cateId) => {
            const urlToPush = addOrDeleteQueryParams(location, [
              { category: cateId === selectedCategoryId ? null : cateId },
            ]);
            changeUrl(urlToPush);
          }}
        />

        <ProductsShow
          items={products}
          selectProductIndex={setSelectProductIndex}
          searchFor={(val) => getProducts(selectedCategoryId, val)}
        />
      </WrapperStyled>

      <Drawer
        variant="temporary"
        open={selectProductIndex !== null}
        onClose={() => {
          getProducts(selectedCategoryId);
          setSelectProductIndex(null);
        }}
        anchor={"right"}
      >
        {selectProductIndex !== null && (
          <ProductInventoryEdit
            site={currentSite}
            item={products[selectProductIndex]}
            close={() => {
              getProducts(selectedCategoryId);
              setSelectProductIndex(null);
            }}
          />
        )}
      </Drawer>
    </div>
  );
};

export default InventoryManagementPage;
